<div class="coupon-layout google-coupon tiktok-layout fixed-header">
  <app-header></app-header>
  <div class="main-content">
    <div class="adcore-logo"><a href="https://www.adcore.com" target="_blank"><i></i></a></div>
    <div class="tiktok-tag" aria-hidden="true">
      <img src="/assets/images/tiktok-partner-badge.png" alt="TikTok">
    </div>
    <div class="content tiktok-hero-copy">
        <span class="title-line">Get <span class="sign bold">$</span><span class="bold">10,000</span> TikTok Ads {{ currentYear }}</span>
        <span class="subtitle-line">coupon in two easy steps</span>
    </div>
    <div class="google-eligible-btn"><button (click)="goToEligibleLink('tiktok')">For eligible accounts only</button></div>
    <div class="link-acc">
      <app-link-steps [step1Text]="'Link your TikTok Ads account'" [step2Text]="'Redeem your TikTok coupon'" [stepMiddleText]="'Checking your eligibility...'" [showMiddleStep]="loading" [accountLinked]="loading"></app-link-steps>
      <div class="buttons">
          <div *ngIf="!loading">
              <div><p-button styleClass="link-btn" label="Link your TikTok Ads account" (onClick)="openRecaptcha('link')"></p-button></div>
              <div class="or">Or</div>
              <div><p-button styleClass="secondary-btn select-coupon" label="Create new account" (onClick)="openRecaptcha('create')"></p-button></div>
          </div>
          <div class="loader-box acc" *ngIf="loading">
            <div class="acc-loader-blue"></div>
          </div>
      </div>
    </div>
    <!-- <app-metrics [merticData]="metricData"></app-metrics> -->
    <app-video-player videoPath="https://www.youtube.com/embed/ApyYbtYY560?autoplay=1&mute=1&loop=1&playlist=ApyYbtYY560&controls=1&playsinline=1&rel=0" [type]="'tiktok'"></app-video-player>
    <app-powered [lang]="'en'" (linkBtnEvent)="openRecaptcha('link')" [isFirstStep]="true" [type]="'tiktok'"></app-powered>
    <app-questions [listItemsType]="'tiktok'" [title]="'Q&A'" [selectedAccordinAIndex]="openTabIndex" (changeSelectedTabIndex)="changeSelectedTabIndex($event)"></app-questions>
    <app-footer [lang]="'en'"></app-footer>
  </div>
</div>
<p-dialog [(visible)]="showDialog" styleClass="create-acc-dialog" [modal]="true" [blockScroll]="true">
  <ng-template pTemplate="header">
    {{dialogHeader}}
    <i class="success-icon" *ngIf="dialogHeader === 'Account created successfully'"></i>
  </ng-template>
  <p>{{dialogBody}}</p>
  <ng-template pTemplate="footer">
    <p-button *ngIf="redeemButton" label="Got it" [disabled]="loading" (onClick)="got_it('create')" styleClass="primary-btn"></p-button>
  </ng-template>
</p-dialog>
<p-toast key="msgTemplate" position="center" (onClose)="close($event)">
    <ng-template let-message pTemplate="message">
      <app-msg-template [message]="message" (confirm)="got_it('link')">
        <div><p>{{message.detail}}</p></div>
      </app-msg-template>
    </ng-template>
</p-toast>
